<nav
  class="relative z-50 container max-w-full mx-auto px-4 py-4 hidden lg:flex justify-between items-center cw:px-[max(32px,calc((100%_-_1328px)/2))]"
  [ngClass]="{
    'bg-transparent': isHomePage || isOverlayed,
    'bg-white dark:bg-transparent': !isHomePage && !isOverlayed
  }"
>
  <a routerLink="/home">
    <img
      class="w-30 md:w-40"
      [src]="isDark ? '/icons/white_Logo.svg' : '/icons/BlueLogo.svg'"
      alt="logo"
    />
  </a>

  <div class="flex items-center justify-between gap-2">
    <app-language-selector />
    <app-currency-selector />

    @if(!isLoggedIn()){
    <a
      routerLink="/business"
      class="px-2.5 py-2 w-fit font-medium text-sm rounded-lg bg-white text-primary dark:border-white dark:bg-transparent dark:text-white"
    >
      {{ "Home_Page.Become_Partner" | translate }}
    </a>
    <button
      routerLink="/manage-account/find-bookings"
      class="px-2.5 py-2.5 w-fit font-medium text-sm rounded-lg bg-white text-secondary dark:bg-white dark:text-primary-dark"
    >
      {{ "Manage_Account.Find_Bookings" | translate }}
    </button>
    <button
      (click)="loginWithPopup()"
      class="px-2.5 py-2.5 w-fit font-medium text-sm rounded-lg bg-secondary text-white dark:bg-white dark:text-primary-dark"
    >
      {{ "Home_Page.Login" | translate }}
    </button>
    }@else{
    <app-profile-menu />
    }

    <!-- <div
      class="flex gap-2 items-center px-3 py-1 rounded-lg"
      [ngStyle]="
        isDark
          ? {
              'box-shadow':
                '2px 2px 20px 0px #369BE740, -2px -2px 40px 0px #369BE740',
              background: '#22225E'
            }
          : { background: '#F1F9FF' }
      "
    >
      <button (click)="setTheme('dark')">
        <img
          src="/icons/moon.svg"
          [src]="isDark ? '/icons/dark_moon.svg' : '/icons/moon.svg'"
          [alt]="isDark ? 'dark_moon' : 'moon'"
        />
      </button>
      <button (click)="setTheme('light')">
        <img
          [src]="isDark ? '/icons/sun.svg' : '/icons/dark_sun.svg'"
          [alt]="isDark ? 'sun' : 'dark sun'"
        />
      </button>
    </div> -->
  </div>
</nav>

<nav
  class="relative z-20 py-3 max-w-full container px-4 mx-auto flex lg:hidden justify-between items-center cw:px-[max(32px,calc((100%_-_1328px)/2))]"
  [ngClass]="{
    'bg-transparent': isHomePage || isOverlayed,
    'bg-white dark:bg-transparent': !isHomePage && !isOverlayed
  }"
>
  <div class="flex justify-between items-center w-full">
    <div class="flex gap-2 items-center">
      <button (click)="openSideMenu()">
        <svg
          class="w-6 h-6 text-secondary dark:text-white"
          aria-hidden="true"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="rtl:hidden"
            clip-rule="evenodd"
            fill-rule="evenodd"
            d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
          ></path>

          <path
            class="hidden rtl:inline"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10zm5.75 4.5a.75.75 0 01.75-.75h8.75a.75.75 0 010 1.5H8.5a.75.75 0 01-.75-.75z"
          ></path>
        </svg>
      </button>
      <app-language-selector />
      <app-currency-selector />
    </div>

    <a routerLink="/home">
      <img
        class="w-30 md:w-40"
        [src]="isDark ? '/icons/white_Logo.svg' : '/icons/BlueLogo.svg'"
        alt="logo"
      />
    </a>
  </div>
  <!-- side menu -->
  <div
    class="fixed top-0 h-full left-0 shadow w-full bg-white dark:bg-primary-dark z-50 transform transition-transform duration-500 ease-in-out"
    [ngClass]="{
    
      'translate-x-0': isMenuOpen,
      '-translate-x-full': !isMenuOpen,
    }"
  >
    <div
      class="flex justify-between items-center p-4 border-b border-[#EAEAEA] dark:border-[#DEEFFD]"
    >
      <a routerLink="/home">
        <img class="w-30 md:w-40" src="/icons/Blue.svg" alt="logo" />
      </a>
      <button
        (click)="closeSideMenu()"
        class="text-[#242456] dark:text-white font-bold"
      >
        ✕
      </button>
    </div>

    <ul class="p-4 space-y-3">
      <li class="py-2">
        <a
          routerLink="/home"
          class="flex items-center gap-2 text-black dark:text-[#F2F2F2] font-medium"
        >
          <img src="/icons/primary.svg" alt="primary" />
          <span> {{ "Search.Button_Search" | translate }} </span>
        </a>
      </li>
      <li class="py-2">
        <div class="flex items-center gap-2 cursor-pointer">
          <img src="/icons/login.svg" alt="login" />

          <button
            (click)="!isLoggedIn() ? loginWithPopup() : openPopupLogout()"
            class="text-black dark:text-[#F2F2F2] font-medium"
          >
            <span>
              {{
                (!isLoggedIn() ? "Home_Page.Login" : "Home_Page.Logout")
                  | translate
              }}
            </span>
          </button>
        </div>
      </li>

      @if(!isLoggedIn()){

      <li class="py-2">
        <a
          routerLink="/manage-account/find-bookings"
          class="flex gap-3 items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="text-primary"
          >
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
          <span class="font-medium text-black dark:text-[#F2F2F2]">
            {{ "Manage_Account.Find_Bookings" | translate }}
          </span>
        </a>
      </li>
      <li class="py-2">
        <a
          routerLink="/business"
          (click)="closeSideMenu()"
          class="flex gap-3 items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="text-primary"
            aria-hidden="true"
          >
            <rect x="3" y="7" width="18" height="13" rx="2"></rect>
            <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
          </svg>
          <span class="font-medium text-black dark:text-[#F2F2F2]">
            {{ "Home_Page.Become_Partner" | translate }}
          </span>
        </a>
      </li>
      } @if(isLoggedIn()){
      <li class="py-2">
        <div class="flex items-center gap-2 cursor-pointer">
          <img src="/icons/login.svg" alt="login" />

          <a
            routerLink="/manage-account"
            [queryParams]="{ tab: 'personalInfo' }"
            class="text-black dark:text-[#F2F2F2] font-medium"
          >
            <span> {{ "Profile.My_Profile" | translate }} </span>
          </a>
        </div>
      </li>
      }
    </ul>
    <div class="bg-[#EAEAEA] dark:bg-[#DEEFFD] h-[1px]"></div>

    <!-- <div class="p-4 space-y-3">
      <div class="flex justify-between items-center">
        <div class="flex gap-3 items-center">
          <img src="/icons/mode.svg" alt="mode" />
          <span class="text-black dark:text-[#F2F2F2] font-medium">{{
            "Home_Page.Mode" | translate
          }}</span>
        </div>
        <div
          class="flex gap-2 items-center px-3 py-1 rounded-lg"
          [ngStyle]="
            isDark
              ? {
                  'box-shadow':
                    '2px 2px 20px 0px #369BE740, -2px -2px 40px 0px #369BE740',
                  background: '#22225E'
                }
              : { background: '#F1F9FF' }
          "
        >
          <button (click)="setTheme('dark')">
            <img
              src="/icons/moon.svg"
              [src]="isDark ? '/icons/dark_moon.svg' : '/icons/moon.svg'"
              [alt]="isDark ? 'dark_moon' : 'moon'"
            />
          </button>
          <button (click)="setTheme('light')">
            <img
              [src]="isDark ? '/icons/sun.svg' : '/icons/dark_sun.svg'"
              [alt]="isDark ? 'sun' : 'dark sun'"
            />
          </button>
        </div>
      </div> 
    </div> -->

    <!-- routes -->

    <div class="p-4 space-y-3">
      <ul>
        <li class="py-2">
          <a routerLink="/about" class="flex gap-3 items-center">
            <img src="/icons/fly-logo.svg" alt="fly-logo" />
            <span class="font-medium text-black dark:text-[#F2F2F2]">
              {{ "About.Title" | translate }}
            </span>
          </a>
        </li>

        <li class="py-2">
          <a routerLink="/contact-us" class="flex gap-3 items-center">
            <img src="/icons/star.svg" alt="star" />

            <span class="font-medium text-black dark:text-[#F2F2F2]">{{
              "Home_Page.Footer.Contact" | translate
            }}</span></a
          >
        </li>
      </ul>
    </div>
  </div>
</nav>
@if(popupIsOpen){
<app-popup-logout (close)="closePopup()" />
}
